module.exports = __webpack_public_path__ + "images/avatar.377e7d00ba5644b065914411f77839c5.png";